/**
 * Generate a small PNG thumbnail from a base64 data URL.
 * Uses PNG to preserve transparency — JPEG converts transparent pixels to black.
 */
const generateThumbnail = (dataUrl, maxSize = 480) => {
  return new Promise((resolve, reject) => {
    if (!dataUrl) { resolve(null); return; }
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => reject(new Error('Failed to load image for thumbnail'));
    img.src = dataUrl;
  });
};

export default generateThumbnail;
